import { Box, IconButton, Typography } from '@mui/material';
import { DeleteIcon } from '@/shared/ui/display/EmojiIcon';
import { ReactNode } from 'react';
import { useAdvancedSearchTheme } from '@/shared/ui/search/AdvancedSearch/theme/useAdvancedSearchTheme';

interface IProps {
  groupNumber: number;
  onDelete?: () => void;
  children: ReactNode;
}

export function FilterGroupCard({ groupNumber, onDelete, children }: IProps) {
  const { filterGroupCardSx, filterGroupHeaderTextSx } = useAdvancedSearchTheme();

  return (
    <Box sx={filterGroupCardSx}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography sx={filterGroupHeaderTextSx}>조건 그룹 {groupNumber}</Typography>
        {onDelete && (
          <IconButton size="small" onClick={onDelete}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>{children}</Box>
    </Box>
  );
}
